// La marque, vue par ses écrans : la vue chaîne (Dashboard), la présence IA,
// les territoires, le deep-dive, BLAST, et les composants qu'ils partagent
// (bande de KPIs, barre de score, pouls d'étude).
export default {
  commun: {
    aujourdhui: 'aujourd\'hui',
    dansJours: 'dans {n} j',
    dansMois: 'dans {n} mois',
    reco: {
      priorite: 'PRIORITÉ',
      considerer: 'À CONSIDÉRER',
      radar: 'RADAR',
    },
    hubIndice: '{mentions} mentions · {auteurs} auteurs distincts',
    moyenneCluster: 'Moyenne cluster {n}',
    fermer: 'fermer',
    chargement: 'Chargement…',
    chargementImpossible: 'Chargement impossible',
    sauvegardeImpossible: 'Sauvegarde impossible',
    presenceIA: 'Présence IA',
    indisponible: 'indisponible',
    partAudience: 'part d\'audience',
    confiance: 'confiance',
    nonSegmente: 'Non segmenté',
    et: '{debut} et {fin}',
    lesAssistants: 'les assistants',
    citation: '« {texte} »',
  },
  chaine: {
    sousTitre: 'Dashboard · score de marque, 4R, persona',
    portefeuille: 'Portefeuille',
    audienceAnalysee: 'audience analysée',
    polarisation: 'Polarisation : {label}',
    genererBrief: 'Générer un brief',
    depuisSnapshot: 'depuis le snapshot du {date}',
    bssInfo: 'Score de marque (BSS) = moyenne pondérée des 4R face au cluster de référence',
    ouvrirDeepDive: 'Ouvrir le deep-dive',
    moyenneCluster: 'moyenne cluster {n}',
    pasDeScore: 'Pas encore de score - lancez une analyse depuis Brand V3.',
    voirFicheComplete: 'Voir la fiche complète (vocabulaire, consommation, univers, comportement)',
    voirFiche: 'Voir la fiche complète',
    autresPersonas: 'Autres personas · {n}',
    personasNonCalculees: 'Personas non calculées pour cette marque.',
    opportunite: 'Opportunité stratégique',
    ouvrirBrief: 'Ouvrir le brief',
    territoires: 'Territoires',
    secondaire: 'Secondaire',
    secondaireTitre: 'Hérité d\'une sous-marque, pas détecté directement sur cette marque - % relatif aux autres territoires secondaires',
    territoiresVide: 'Territoires non détectés - lancez une analyse (ils se détectent à l\'audit).',
    audienceDit: 'Ce que votre audience dit',
    audienceDitVide: 'Pas assez de signaux pour extraire des mentions récurrentes.',
    elleSuit: 'Ce qu\'elle suit',
    chaineSuivie: 'chaîne suivie',
    affinite: 'affinité {n}%',
    infere: 'inféré',
    infereTitre: 'Inféré par l\'analyse - à confirmer',
    affinitesVide: 'Affinités non disponibles - calculez les personas V2.',
    prochainsEvenements: 'Prochains événements',
    extraitCalendrier: 'Extrait du calendrier généré le {date}',
    aucunEvenement: 'Aucun événement à venir dans le calendrier.',
    pasDeCalendrier: 'Pas encore de calendrier - générez-le après un audit.',
    voirCalendrier: 'voir le calendrier du dossier →',
    mesureeLe: 'mesurée le {date}',
    nouvelleMesure: 'nouvelle mesure en cours',
    ensemble: 'ensemble',
    muetTitre: '{nom} n\'a répondu à aucune question (clé ou crédits) : ce n\'est pas « ne cite pas »',
    citeTitre: '{nom} cite la marque dans {pct} % des questions où elle n\'est pas nommée',
    premiereMesure: 'Première mesure en cours : les scores arrivent à sa fin.',
    pasMesuree: 'Pas encore mesurée : ce que les assistants répondent sur la marque se mesure au prochain audit profond.',
    voirReponses: 'voir chaque réponse →',
    pleinePage: 'pleine page ↗',
    pleinePageTitre: 'Ouvrir en pleine page',
  },
  presence: {
    dansAssistants: '{marque} dans les assistants',
    sous: 'Ce que {assistants} répondent quand on leur pose les questions qu\'un utilisateur pose, sans que la marque soit nommée. Citée ? À quel rang ? Face à qui ?',
    mesureEnCours: 'mesure en cours : les scores arrivent à sa fin',
    mesureeLe: 'Mesurée le {date}.',
    seRemesure: 'Se remesure à chaque audit profond de la marque.',
    lecture: 'Lecture…',
    aucune: 'Aucune mesure encore. La présence IA se mesure pendant l\'audit profond de la marque : neuf questions posées à six assistants, de l\'ordre d\'un dollar. Elle apparaîtra ici, et dans le rapport d\'audit, à la fin du prochain audit profond.',
    citeeSpontanement: 'citée spontanément',
    positionMoyenne: 'position moyenne',
    partDeVoix: 'part de voix',
    connaissance: 'connaissance',
    indispo: 'indisponible : {n} question(s) sans réponse',
    indispoNote: '(clé ou crédits ; ce n\'est pas « ne cite pas »)',
    enCours: 'en cours',
    ensemble: 'Ensemble',
    formule: '60 % présence · 25 % position · 15 % connaissance : une formule posée, écrite pour être changée.',
    cout: "Coût {montant} {'$'}.",
    question: 'Question',
    spontanee: 'spontanée',
    assistee: 'assistée',
    citee: 'citée',
    absente: 'absente',
    connaissances: {
      fidele: 'fidele',
      approximative: 'approximative',
      confondue: 'confondue',
      inconnue: 'inconnue',
    },
    tons: {
      positif: 'positif',
      neutre: 'neutre',
      negatif: 'negatif',
      mixte: 'mixte',
    },
  },
  kpi: {
    jumeaux: '{n} ISO | {n} ISO | {n} ISOs',
    age: 'Âge',
    genre: 'Genre',
    homme: 'H',
    femme: 'F',
    nonBinaire: 'NB',
    plateformes: 'Plateformes',
    webAutre: 'Web / autre',
    creneaux: 'Créneaux',
    creneau: {
      Matin: 'Matin',
      Midi: 'Midi',
      Soir: 'Soir',
      Nuit: 'Nuit',
    },
    tauxClic: 'Taux de clic',
    filClic: 'du fil déclenche un clic',
    pasDeFil: 'pas de fil sur cette sortie',
    ressenti: 'Ressenti',
    aime: 'aime {n}',
    mitige: 'mitigé {n}',
    decroche: 'décroche {n}',
    aucunClic: 'aucun clic sur le fil',
  },
  pulse: {
    legende: 'jumeaux interrogés · en parallèle, chacun en aveugle des autres',
    enCours: 'Interrogations en cours',
    consolide: 'Consolidé',
  },
  territoires: {
    titre: 'Mes Territoires',
    sousTitre: 'Les territoires de {marque} - enrichis par vos ISOs',
    chargement: 'Chargement des territoires…',
    pctMarque: ' % de la marque',
    isosEnrichi: 'ISOs ont enrichi le territoire · 30 j',
    isosEnrichiTitre: 'Sorties d\'ISOs de votre marque ayant rapporté du signal sur ce territoire (30 derniers jours)',
    sessions: 'sessions · 7 j',
    sessionsTitre: 'Sessions terrain exécutées sur les 7 derniers jours',
    persistants: 'signaux persistants',
    persistantsTitre: 'Créateurs et sujets qui persistent dans les observations de VOS ISOs (un signal doit se répéter pour compter)',
    ecarts: 'écarts perçu vs attendu',
    ecartsTitre: 'Écarts perçus vs attendus détectés en Arène - matière à décisions',
    dernierTerrain: 'dernier terrain {date}',
    aucunTerrain: 'aucun terrain pour l\'instant',
    envoyer: 'Envoyer des ISOs',
    vide: 'Aucun territoire détecté - lancez une analyse (ils se détectent à l\'audit).',
  },
  deepDive: {
    sousTitre: '{marque} · anatomie uniforme : métrique → graphique → pourquoi → comment → quoi faire → sourcing',
    moyenneCluster: 'moyenne cluster',
    calcul: 'Calcul du deep-dive (metrics + insights)…',
    pourquoi: 'Pourquoi ça compte',
    comment: 'Comment c\'est calculé',
    methode: 'Score normalisé 0-100 contre le cluster de référence (fenêtre 90 jours glissants, recalcul à chaque analyse). Aucune modélisation générative dans le score : uniquement des signaux mesurés (métriques d\'engagement, occurrences, sentiment calculé par lot).',
    metriquesEntree: 'Métriques d\'entrée : {liste}.',
    quoiFaire: 'Ce que ça veut dire - quoi faire',
    analyseEnCours: 'Analyse en cours…',
    insightsIndispo: 'Insights indisponibles - relancez le deep-dive après une analyse.',
    sourcingTexte: 'Chaque point est reconstructible depuis les signaux persistés (source_url + raw_payload sur chaque ligne). Les données YouTube brutes sont purgées à 30 jours (ToS III.E.4) - seuls les scores agrégés persistent.',
    signauxRetenus: '{n} signaux retenus sur {plateforme}',
    scoreCalcule: 'score calculé le {date}',
    dateCalcul: 'Date du dernier calcul Brand Strength',
  },
  blast: {
    sousTitre: 'Build · Launch · Analyze · Scale or Terminate - 1 variable par short',
    deplacementNonSauve: 'Déplacement non sauvegardé',
    verdictNonEnregistre: 'Verdict non enregistré',
    aucune: 'Aucune campagne BLAST',
    aucuneTexte: 'Une campagne naît d\'un brief : ouvrez le brief d\'une marque et cliquez « Envoyer en BLAST ». Orion génère un plan de test - chaque short isole une variable, avec hypothèse falsifiable et KPI cible.',
    allerPortefeuille: 'Aller au portefeuille',
    campagne: 'Campagne « {territoire} » - {objectif}.',
    objectifDefaut: '1 variable isolée par short',
    glissez: 'Glissez les cards entre colonnes.',
    statuts: {
      draft: 'brouillon',
      running: 'en cours',
      scaled: 'scaled',
      terminated: 'terminated',
    },
    enregistrementVerdict: 'Enregistrement du verdict…',
    scaleTitre: 'Le territoire est validé - on investit en production lourde',
    terminateTitre: 'Le territoire est infirmé - on arrête',
    iterateTitre: 'Résultats ambigus - nouvelle itération de tests',
    dernierVerdict: 'Dernier verdict : {decision} le {date}',
    preTitre: 'Pré-score estimé (panel persona) - descriptif, à valider par la mesure',
    pre: 'pré',
    reel: 'réel',
    kpiAtteint: 'KPI atteint',
    kpiManque: 'KPI manqué',
    scoreReel: 'Score réel',
    kpiAtteintQuestion: 'KPI atteint ?',
    oui: 'oui',
    non: 'non',
    enregistrer: 'Enregistrer',
    consignerTitre: 'Consigner le résultat de ce test',
    annuler: 'annuler',
    modifier: 'modifier',
    saisir: 'saisir le résultat',
  },
}
